/**
 * The steps of the booking flow, and the rule that decides when the browser's
 * back button belongs to the flow and when it belongs to the browser.
 */

export type Phase =
  | 'listing'
  | 'selecting'
  | 'prepayment'
  | 'booking'
  | 'confirmation'
  | 'error'; // location is currently disabled

// The steps the flow walks back through. Anything not listed (confirmation,
// error) has nowhere to step back to and is treated as terminal.
export const PHASE_ORDER: Phase[] = ['listing', 'selecting', 'prepayment', 'booking'];

// The steps whose URL carries `?book=`, so refreshing resumes on them.
export const BOOKING_PHASES: Phase[] = ['prepayment', 'booking'];

/**
 * How far along the flow a step is, used to tell a step forward (which pushes a
 * history entry, so the browser's back button has one step to undo) from a step
 * back or sideways (which replaces it).
 *
 * Steps outside PHASE_ORDER — confirmation, error — sort before the first step,
 * so arriving at one never pushes an entry.
 */
export const phaseIndex = (phase: Phase) => PHASE_ORDER.indexOf(phase);
